import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { StepProps } from '../../@types/step'
import { useReportViewEvent } from '../../hooks'
import { ReduxState } from '../../store/reducers'
import { reportTrackingEvent } from '../../tracking/thunks'
import { RadiusStepIcon } from '../../components/icons/StepIcons/RadiusStepIcon'
import { StepTemplate } from '../../components/styled/stepTemplate/StepTemplate'
import Location from '../../components/Location/Location'
import LocationRadius from '../../components/LocationRadius/LocationRadius'
import { updateLocationRange } from '../../store/location/locationSlice'

const HEADLINE = 'In welchem Radius suchst du?'
export const PAGE_TITLE = 'buyer-radius'

const RadiusStep = (props: Required<StepProps>) => {
  useReportViewEvent({ pageTitle: PAGE_TITLE })
  const {
    config: { theme },
    location: { data: location },
  } = useSelector((state: ReduxState) => state)
  const [isLocationValid, setIsLocationValid] = React.useState<boolean>(false)
  const [isRadiusValid, setIsRadiusValid] = React.useState<boolean>(true)

  const isNextEnabled: boolean = isLocationValid && isRadiusValid

  const dispatch = useDispatch()

  const onNextClick = () => {
    dispatch(
      reportTrackingEvent({
        pageTitle: PAGE_TITLE,
        category: 'residential',
        action: 'realtor-leadengine',
        label: 'postcode_submit',
        eventName: 'lead_input',
        flow: 'IBW',
        inputValue: location?.postcode ?? '',
        customDimensions: { ga_cd_lead_engine_input_value: location?.postcode },
      })
    )
    if (typeof props.goToNextStep === 'function') props.goToNextStep()
  }

  const onLocationRadiusChange = (value?: number, isValid?: boolean) => {
    dispatch(
      reportTrackingEvent({
        pageTitle: PAGE_TITLE,
        category: 'residential',
        action: 'realtor-leadengine',
        label: 'range_submit',
        eventName: 'lead_input',
        flow: 'IBW',
        inputValue: value?.toString() ?? '',
        customDimensions: { ga_cd_lead_engine_input_value: value },
      })
    )
    setIsRadiusValid(isValid ?? false)
    if (isValid && typeof value === 'number') {
      dispatch(updateLocationRange(value))
    }
  }

  return (
    <StepTemplate
      headline={HEADLINE}
      icon={<RadiusStepIcon />}
      displayNext={true}
      displayBack={props.displayBack}
      progress={props.progress}
      isNextEnabled={isNextEnabled}
      goToNextStep={onNextClick}
      goToPreviousStep={props.goToPreviousStep}
      dataTestingButton='radius-next-button'
      backgroundColor={theme.background}
      textColor={theme.text}
    >
      <Location onValidationChange={setIsLocationValid} onError={props.goToErrorStep} autofocus={false} />
      <LocationRadius className='padding-top-m' onChange={onLocationRadiusChange} />
    </StepTemplate>
  )
}

export default RadiusStep
